export default "__VITE_ASSET__DIXPxVgi__"